import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../index';
import {
  createSpecialistReview,
  getApprovedSpecialistReviews,
  getClientSpecialistsReviews,
  getRatedSpecialist,
  updateSpecialistReview,
} from '../../api/specialist/reviews';
import { CreateSpecialistReviewData, UpdatedSpecialistReviewData, UpdateSpecialistReviewData } from './types';
import { REVIEW_COUNT_PER_PAGE } from './constants';
import { SpecialistReview } from '@mindly/ui-components';

export const createReview = createAsyncThunk(
  'specialistReviews/createReview',
  async (data: CreateSpecialistReviewData) => {
    const response: SpecialistReview = await createSpecialistReview(data);

    return (await response) as SpecialistReview;
  }
);

export const updateReview = createAsyncThunk(
  'specialistReviews/updateReview',
  async (data: UpdateSpecialistReviewData) => {
    const response: UpdatedSpecialistReviewData = await updateSpecialistReview(data);

    return (await response) as UpdatedSpecialistReviewData;
  }
);

export const fetchReviews = createAsyncThunk(
  'specialistReviews/fetchReviews',
  async (
    { specialistID, showEditableForClientId }: { specialistID: string; showEditableForClientId?: string },
    thunkAPI
  ): Promise<{ data: SpecialistReview[]; specialistID: string }> => {
    const {
      specialistReviews: { reviews },
    } = thunkAPI.getState() as RootState;
    const { limit, offset } = reviews?.[specialistID] ?? {
      limit: REVIEW_COUNT_PER_PAGE,
      offset: 0,
    };

    const response = await getApprovedSpecialistReviews(specialistID, showEditableForClientId ?? '', limit, offset);

    return { data: response, specialistID };
  }
);

export const fetchClientSpecialistsReviews = createAsyncThunk(
  'specialistReviews/fetchClientSpecialistsReviews',
  async () => {
    const response = await getClientSpecialistsReviews();
    return response;
  }
);

export const fetchRatedSpecialists = createAsyncThunk(
  'specialistReviews/fetchRatedSpecialists',
  async (clientID?: string) => {
    if (!clientID) throw new Error('client_id_required');

    const response = await getRatedSpecialist(clientID);
    return response.map((review) => review?.specialist_id) ?? null;
  }
);
